import { Provider } from 'store/api/enums';
import type { Organisation } from 'store/organisation/models';

/**
 * Returns the group organisation that lists this member in `groupedConnections`, if any.
 */
export function findGroupOrganisationForMember(
  organisations: Organisation[] | undefined,
  memberOrganisationId: string | undefined
): Organisation | undefined {
  if (!Array.isArray(organisations) || organisations.length === 0) {
    return undefined;
  }
  if (!memberOrganisationId) return undefined;
  return organisations.find(
    (o) =>
      o.providerName?.toLowerCase() === Provider.GROUP.toLowerCase() &&
      o.groupedConnections?.some((gc) => gc.uuid === memberOrganisationId)
  );
}
